import { ancoraPorId, cofreMotor, yDaLongarina, zParaFogo, type PerfilVeiculo } from '../../dominio/didatico/perfilVeiculo'
import { MaterialPeca, Peca } from '../componentes/Peca'
import { Barra } from '../componentes/Barra'
import { vetor } from '../../dominio/geometria/vetor3'

type Ponto = [number, number, number]

function Caixa({ id, posicao, tamanho, cor }: { id: string; posicao: Ponto; tamanho: Ponto; cor?: string }) {
  return <mesh position={posicao}><boxGeometry args={tamanho} /><MaterialPeca id={id} corBase={cor} /></mesh>
}

function Linha({ id, de, para, espessura = 0.012 }: { id: string; de: Ponto; para: Ponto; espessura?: number }) {
  return <Barra id={id} de={vetor(...de)} para={vetor(...para)} largura={espessura} espessura={espessura} cilindrica />
}

/** Detalhes exclusivos da exploração anatômica; sem custo nas cenas com vários veículos. */
export function DetalhesAnatomia3D({ perfil }: { perfil: PerfilVeiculo }) {
  const motorista = ancoraPorId(perfil, 'motorista')
  const cofre = cofreMotor(perfil)
  const zMotor = (cofre.zDianteiro + cofre.zTraseiro) / 2
  const yBase = yDaLongarina(perfil)
  const xFreio = perfil.largura / 2 - perfil.larguraRoda * 0.72
  const yFreio = perfil.raioRoda
  const zFreio = perfil.eixoDianteiroZ
  const raioDisco = perfil.raioRoda * 0.49
  const servo: Ponto = [motorista.posicao.x, perfil.capoY - 0.24, zParaFogo(perfil) + 0.14]
  const abs: Ponto = [-perfil.largura * 0.32, perfil.capoY - 0.32, cofre.zTraseiro + 0.25]
  const yConsole = perfil.pisoY + 0.17

  return <group name="detalhes-anatomia">
    <Peca id="freiosDianteiros" deslocamentoAfastado={[0, 0.25, 0.35]}>
      {[-1, 1].map(lado => <group key={lado} position={[lado * xFreio, yFreio, zFreio]} rotation={[0, 0, Math.PI / 2]}>
        {[-0.016, 0.016].map(y => <mesh key={y} position={[0, y, 0]}>
          <cylinderGeometry args={[raioDisco, raioDisco, 0.014, 40]} />
          <MaterialPeca id="freiosDianteiros" acabamento="metal" />
        </mesh>)}
        <mesh><cylinderGeometry args={[raioDisco * 0.44, raioDisco * 0.44, 0.065, 24]} /><MaterialPeca id="freiosDianteiros" metalico={0.65} /></mesh>
        {Array.from({ length: 12 }, (_, i) => <mesh key={i} rotation={[0, i * Math.PI / 6, 0]}>
          <boxGeometry args={[raioDisco * 1.9, 0.025, 0.012]} /><MaterialPeca id="freiosDianteiros" metalico={0.65} />
        </mesh>)}
      </group>)}
    </Peca>
    <Peca id="pincasFreio" deslocamentoAfastado={[0, 0.4, 0.35]}>
      {[-1, 1].map(lado => <group key={lado}>
        <Caixa id="pincasFreio" posicao={[lado * xFreio, yFreio + raioDisco * 0.25, zFreio - raioDisco * 0.72]} tamanho={[0.10, raioDisco * 1.12, 0.09]} cor="#b46239" />
        {[-1, 1].map(face => <Caixa key={face} id="pincasFreio" posicao={[lado * xFreio + face * 0.036, yFreio + raioDisco * 0.25, zFreio - raioDisco * 0.54]} tamanho={[0.015, raioDisco * 0.78, 0.04]} cor="#303238" />)}
      </group>)}
    </Peca>
    <Peca id="servoFreio">
      <mesh position={servo} rotation={[Math.PI / 2, 0, 0]}><cylinderGeometry args={[0.13, 0.13, 0.09, 24]} /><MaterialPeca id="servoFreio" corBase="#343940" metalico={0.5} /></mesh>
    </Peca>
    <Peca id="cilindroMestre">
      <mesh position={[servo[0], servo[1], servo[2] + 0.14]} rotation={[Math.PI / 2, 0, 0]}><cylinderGeometry args={[0.034, 0.042, 0.22, 16]} /><MaterialPeca id="cilindroMestre" acabamento="metal" /></mesh>
      <Caixa id="cilindroMestre" posicao={[servo[0], servo[1] + 0.09, servo[2] + 0.15]} tamanho={[0.10, 0.10, 0.15]} cor="#ddd6ba" />
      <mesh position={[servo[0], servo[1] + 0.15, servo[2] + 0.15]}><cylinderGeometry args={[0.033, 0.033, 0.02, 16]} /><MaterialPeca id="cilindroMestre" corBase="#343940" /></mesh>
    </Peca>
    <Peca id="moduloAbs">
      <Caixa id="moduloAbs" posicao={abs} tamanho={[0.17, 0.12, 0.13]} />
      <mesh position={[abs[0], abs[1], abs[2] + 0.12]} rotation={[Math.PI / 2, 0, 0]}><cylinderGeometry args={[0.055, 0.055, 0.12, 16]} /><MaterialPeca id="moduloAbs" corBase="#343940" /></mesh>
      <Caixa id="moduloAbs" posicao={[abs[0], abs[1] + 0.075, abs[2]]} tamanho={[0.15, 0.03, 0.12]} cor="#303238" />
    </Peca>
    <Peca id="linhasFreio">
      <Linha id="linhasFreio" de={[servo[0], servo[1], servo[2] + 0.22]} para={[abs[0], abs[1], abs[2]]} />
      {[-1, 1].map(lado => <group key={lado}>
        <Linha id="linhasFreio" de={abs} para={[lado * xFreio * 0.8, yBase + 0.1, zFreio - 0.2]} />
        <Linha id="linhasFreio" de={[lado * xFreio * 0.8, yBase + 0.1, zFreio - 0.2]} para={[lado * xFreio, yFreio, zFreio - raioDisco * 0.72]} espessura={0.018} />
      </group>)}
    </Peca>
    {perfil.energia.propulsao !== 'eletrico' && <Peca id="carterMotor" deslocamentoAfastado={[0, -0.15, 0.25]}>
      <Caixa id="carterMotor" posicao={[perfil.tracao === 'dianteira' ? 0.12 : 0, yBase + 0.06, zMotor]} tamanho={[perfil.tracao === 'dianteira' ? perfil.largura * 0.37 : 0.38, 0.14, 0.36]} cor="#525965" />
    </Peca>}
    <Peca id="consoleCentral" deslocamentoAfastado={[0, 0.45, 0]}>
      <Caixa id="consoleCentral" posicao={[0, yConsole, motorista.posicao.z + 0.16]} tamanho={[0.19, 0.20, 0.48]} cor="#303944" />
      <mesh position={[0, yConsole + 0.105, motorista.posicao.z]} rotation={[-Math.PI / 2, 0, 0]}><ringGeometry args={[0.028, 0.038, 20]} /><MaterialPeca id="consoleCentral" corBase="#aab2be" /></mesh>
    </Peca>
    <Peca id="seletorMarchas">
      <mesh position={[0, yConsole + 0.17, motorista.posicao.z + 0.26]}><cylinderGeometry args={[0.014, 0.02, 0.15, 12]} /><MaterialPeca id="seletorMarchas" metalico={0.7} /></mesh>
      <mesh position={[0, yConsole + 0.25, motorista.posicao.z + 0.26]} scale={[1, 0.8, 1]}><sphereGeometry args={[0.035, 16, 12]} /><MaterialPeca id="seletorMarchas" corBase="#343940" /></mesh>
    </Peca>
    <Peca id="quadroInstrumentos">
      <group position={[motorista.posicao.x, perfil.cinturaY - 0.10, perfil.colunaA.zBase - 0.34]} rotation={[0.15, 0, 0]}>
        <Caixa id="quadroInstrumentos" posicao={[0, 0, 0]} tamanho={[0.27, 0.115, 0.025]} cor="#202833" />
        {[-0.065, 0.065].map(x => <group key={x} position={[x, 0, -0.014]} rotation={[0, Math.PI, 0]}>
          <mesh><ringGeometry args={[0.035, 0.04, 24]} /><MaterialPeca id="quadroInstrumentos" corBase="#ced9df" /></mesh>
          <mesh rotation={[0, 0, -0.6]} position={[0.007, 0.008, 0.001]}><boxGeometry args={[0.004, 0.036, 0.003]} /><MaterialPeca id="quadroInstrumentos" corBase="#ec9466" /></mesh>
        </group>)}
      </group>
    </Peca>
    <Peca id="trilhosBancos">
      {perfil.ancoras.filter(a => a.fila === 'dianteira').flatMap(a => [-1, 1].map(lado =>
        <Caixa key={`${a.id}-${lado}`} id="trilhosBancos" posicao={[a.posicao.x + lado * 0.15, perfil.pisoY + 0.055, a.posicao.z]} tamanho={[0.032, 0.06, 0.47]} cor="#87919e" />
      ))}
    </Peca>
    <Peca id="isofix">
      {perfil.ancoras.filter(a => a.fila === 'traseira' && a.lado !== 'central').flatMap(a => [-1, 1].map(lado =>
        <mesh key={`${a.id}-${lado}`} position={[a.posicao.x + lado * 0.14, a.alturaAssento + 0.02, a.posicao.z - 0.13]} rotation={[Math.PI / 2, 0, 0]}>
          <torusGeometry args={[0.024, 0.006, 8, 16]} /><MaterialPeca id="isofix" corBase="#f4b860" metalico={0.65} />
        </mesh>
      ))}
    </Peca>
  </group>
}
